import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  IDownloadReportListItem,
} from '../types';
import {
  DOWNLOAD_REPORT_LIST_QUERY_KEY,
  DOWNLOAD_REPORT_LIST_URL,
  DOWNLOAD_REPORT_PERMISSIONS,
} from '../constants';

export default function useDownloadReportListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IDownloadReportListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IDownloadReportListItem>>({
    queryKey: [DOWNLOAD_REPORT_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IDownloadReportListItem>>(
      DOWNLOAD_REPORT_LIST_URL,
      tableState.value,
      {
        signal,
        permission: DOWNLOAD_REPORT_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
